// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./navbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./home.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./analyze.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./docs.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Light Mode (Default) */
  --bg-color: #f8fafc;
  --text-color: #1e293b;
  --card-bg: #ffffff;
  --border-color: #f1f5f9;
  --primary-blue: #3b82f6;
  --primary-purple: #8b5cf6;
  --muted-text: #64748b;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

[data-theme="dark"] {
  /* Dark Mode Palette */
  --bg-color: #0f172a; /* Slate 900 */
  --text-color: #f1f5f9;
  --card-bg: #1e293b; /* Slate 800 */
  --border-color: #334155;
  --muted-text: #94a3b8;
}

body {
  background-color: var(--bg-color);
  color: var(--text-color);
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

.bento-card,
.timeline-content,
.modern-accordion,
.docs-sidebar {
  background-color: var(--card-bg) !important;
  border-color: var(--border-color) !important;
  color: var(--text-color);
}

.text-muted {
  color: var(--muted-text) !important;
}

/* --- TYPOGRAPHY --- */
.fw-800 {
  font-weight: 800;
}
.fw-700 {
  font-weight: 700;
}
.fw-600 {
  font-weight: 600;
}

.tracking-widest {
  letter-spacing: 0.1em;
}
.line-height-relaxed {
  line-height: 1.6;
}

.text-purple {
  color: var(--primary-purple);
}
.text-primary {
  color: var(--primary-blue) !important;
}

.label-caps {
  display: block;
  font-size: 10px;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

/* --- LAYOUT & BORDERS --- */
.shadow-soft {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

.border-top-dash {
  border-top: 1px dashed #e2e8f0;
}

.rounded-4 {
  border-radius: 1rem !important;
}
.rounded-5 {
  border-radius: 1.5rem !important;
}

/* --- TEXT CLAMPING --- */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  white-space: normal;
}

/* --- UTILITY ANIMATIONS --- */
.page-transition {
  opacity: 0;
  transform: translateY(15px);
  transition:
    opacity 0.4s ease-out,
    transform 0.4s ease-out;
}

.pulse-animation {
  animation: pulse-text 2s infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse-text {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

/* --- CURSOR HELPERS --- */
.cursor-pointer {
  cursor: pointer;
}

.main-content-wrapper {
  min-height: 100vh;
}

.main-gradient-text {
  background: linear-gradient(
    90deg,
    var(--primary-blue),
    var(--primary-purple)
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn-purple {
  background: linear-gradient(135deg, var(--primary-purple), #6d28d9);
  color: white;
  border: none;
}

.top-progress-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  z-index: 100001;
  pointer-events: none;
}

.top-progress-bar {
  height: 100%;
  width: 0;
  background-color: #3b82f6;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.5);
  transition:
    width 0.3s ease,
    opacity 0.4s ease;
  opacity: 0;
}

.page-transition.active {
  opacity: 1;
  transform: translateY(0);
}

.analysis-loader {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  z-index: 10;
}

.analysis-loader.active {
  display: flex;
}

.analysis-spinner {
  width: 40px;
  height: 40px;
  border: 6px solid #ffe0b2;
  border-top: 6px solid #ffa559;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.lazyload {
  opacity: 0;
  transition: opacity 0.5s;
}

.lazyloaded {
  opacity: 1;
}

.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.popup-overlay.active {
  opacity: 1;
  visibility: visible;
}

.popup-box {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  width: 90%;
  max-width: 400px;
  transform: scale(0.8);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.popup-overlay.active .popup-box {
  transform: scale(1);
}

.popup-message {
  font-size: 1.1rem;
  color: #333;
  font-weight: 500;
}

.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.popup-message {
  font-weight: 600;
  color: #444;
}

@media (max-width: 580px) {
  .go-to-top {
    width: 35px;
    height: 35px;
    font-size: 22px;
    line-height: 0;
    border-radius: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAOA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB,EAAE,cAAc;EACnC,qBAAqB;EACrB,kBAAkB,EAAE,cAAc;EAClC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB;;mBAEiB;AACnB;;AAEA;;;;EAIE,2CAA2C;EAC3C,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,2BAA2B;EAC3B;;2BAEyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;EAC3C;;qBAEmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import \"navbar.css\";\n@import \"home.css\";\n@import \"footer.css\";\n@import \"analyze.css\";\n@import \"docs.css\";\n\n:root {\n  /* Light Mode (Default) */\n  --bg-color: #f8fafc;\n  --text-color: #1e293b;\n  --card-bg: #ffffff;\n  --border-color: #f1f5f9;\n  --primary-blue: #3b82f6;\n  --primary-purple: #8b5cf6;\n  --muted-text: #64748b;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Poppins\", sans-serif;\n}\n\n[data-theme=\"dark\"] {\n  /* Dark Mode Palette */\n  --bg-color: #0f172a; /* Slate 900 */\n  --text-color: #f1f5f9;\n  --card-bg: #1e293b; /* Slate 800 */\n  --border-color: #334155;\n  --muted-text: #94a3b8;\n}\n\nbody {\n  background-color: var(--bg-color);\n  color: var(--text-color);\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\n.bento-card,\n.timeline-content,\n.modern-accordion,\n.docs-sidebar {\n  background-color: var(--card-bg) !important;\n  border-color: var(--border-color) !important;\n  color: var(--text-color);\n}\n\n.text-muted {\n  color: var(--muted-text) !important;\n}\n\n/* --- TYPOGRAPHY --- */\n.fw-800 {\n  font-weight: 800;\n}\n.fw-700 {\n  font-weight: 700;\n}\n.fw-600 {\n  font-weight: 600;\n}\n\n.tracking-widest {\n  letter-spacing: 0.1em;\n}\n.line-height-relaxed {\n  line-height: 1.6;\n}\n\n.text-purple {\n  color: var(--primary-purple);\n}\n.text-primary {\n  color: var(--primary-blue) !important;\n}\n\n.label-caps {\n  display: block;\n  font-size: 10px;\n  font-weight: 800;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n/* --- LAYOUT & BORDERS --- */\n.shadow-soft {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);\n}\n\n.border-top-dash {\n  border-top: 1px dashed #e2e8f0;\n}\n\n.rounded-4 {\n  border-radius: 1rem !important;\n}\n.rounded-5 {\n  border-radius: 1.5rem !important;\n}\n\n/* --- TEXT CLAMPING --- */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.4;\n  white-space: normal;\n}\n\n/* --- UTILITY ANIMATIONS --- */\n.page-transition {\n  opacity: 0;\n  transform: translateY(15px);\n  transition:\n    opacity 0.4s ease-out,\n    transform 0.4s ease-out;\n}\n\n.pulse-animation {\n  animation: pulse-text 2s infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse-text {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* --- CURSOR HELPERS --- */\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.main-content-wrapper {\n  min-height: 100vh;\n}\n\n.main-gradient-text {\n  background: linear-gradient(\n    90deg,\n    var(--primary-blue),\n    var(--primary-purple)\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.btn-purple {\n  background: linear-gradient(135deg, var(--primary-purple), #6d28d9);\n  color: white;\n  border: none;\n}\n\n.top-progress-bar-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  z-index: 100001;\n  pointer-events: none;\n}\n\n.top-progress-bar {\n  height: 100%;\n  width: 0;\n  background-color: #3b82f6;\n  box-shadow: 0 0 8px rgba(59, 130, 246, 0.5);\n  transition:\n    width 0.3s ease,\n    opacity 0.4s ease;\n  opacity: 0;\n}\n\n.page-transition.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.analysis-loader {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.85);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1rem;\n  z-index: 10;\n}\n\n.analysis-loader.active {\n  display: flex;\n}\n\n.analysis-spinner {\n  width: 40px;\n  height: 40px;\n  border: 6px solid #ffe0b2;\n  border-top: 6px solid #ffa559;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.lazyload {\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n.lazyloaded {\n  opacity: 1;\n}\n\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.popup-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.popup-box {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1.5rem;\n  width: 90%;\n  max-width: 400px;\n  transform: scale(0.8);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.popup-overlay.active .popup-box {\n  transform: scale(1);\n}\n\n.popup-message {\n  font-size: 1.1rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.popup-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.popup-message {\n  font-weight: 600;\n  color: #444;\n}\n\n@media (max-width: 580px) {\n  .go-to-top {\n    width: 35px;\n    height: 35px;\n    font-size: 22px;\n    line-height: 0;\n    border-radius: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
